export { default } from "./DatoCmsHighlight";
